import _ from 'underscore';
import React from 'react';
import { CountriesPanel } from 'javascripts/analytics/components/countries_panel';
import { DocumentsTabChart } from 'javascripts/analytics/components/documents_tab_chart';
import { NoDataTab } from 'javascripts/analytics/components/NoDataTab';
import { PremiumHitsTable } from 'javascripts/analytics/components/premium_hits_table';
import { Link } from 'react-router-dom';
import { ImpactTabContainer } from './impact_tab/impact_tab_container';
import { CVAnalyticsTab } from 'js/analytics/components/CVAnalyticsTab.wjs';

export class DocumentsShowContainer extends React.Component {
  docId = () => {
    return parseInt(this.props.match.params.docId, 10);
  };

  // This cannot be a function of props, since it doesn't update when
  // props change, which can happen when the document changes.
  getStateFromStore = () => {
    return {
      docs: Aedu.ReduxStore.getState().AnalyticsDashboard.Docs.models,
      hits: Aedu.ReduxStore.getState().AnalyticsDashboard.Hits.models,
      previousDateRangeHits:
        Aedu.ReduxStore.getState().AnalyticsDashboard.PreviousDateRangeHits,
      downloads: Aedu.ReduxStore.getState().AnalyticsDashboard.Downloads.models,
      previousDateRangeDownloads:
        Aedu.ReduxStore.getState().AnalyticsDashboard
          .PreviousDateRangeDownloads,
      fetching:
        Aedu.ReduxStore.getState().AnalyticsDashboard.Docs.meta.fetching ||
        Aedu.ReduxStore.getState().AnalyticsDashboard.Hits.meta.fetching ||
        Aedu.ReduxStore.getState().AnalyticsDashboard.PreviousDateRangeHits.meta
          .fetching ||
        Aedu.ReduxStore.getState().AnalyticsDashboard.Downloads.meta.fetching ||
        Aedu.ReduxStore.getState().AnalyticsDashboard.PreviousDateRangeDownloads
          .meta.fetching,
      displayedDates:
        Aedu.ReduxStore.getState().AnalyticsDashboard.DisplayedDates,
    };
  };

  componentDidMount() {
    this.unsubscribe = Aedu.ReduxStore.subscribe(
      function () {
        this.setState(this.getStateFromStore());
      }.bind(this),
    );

    Aedu.ReduxStore.dispatch(
      Aedu.ActionCreators.AnalyticsDashboard.Docs.fetch(),
    );
    Aedu.ReduxStore.dispatch(
      Aedu.ActionCreators.AnalyticsDashboard.Hits.fetch(),
    );
    Aedu.ReduxStore.dispatch(
      Aedu.ActionCreators.AnalyticsDashboard.Downloads.fetch(),
    );
    Aedu.ReduxStore.dispatch(
      Aedu.ActionCreators.AnalyticsDashboard.PreviousDateRangeHits.fetch(),
    );
    Aedu.ReduxStore.dispatch(
      Aedu.ActionCreators.AnalyticsDashboard.PreviousDateRangeDownloads.fetch(),
    );
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  render() {
    const doc = _.findWhere(this.state.docs, { id: this.docId() });
    const hits = _.filter(
      this.state.hits,
      function (hit) {
        return hit.page && hit.page.work_id === this.docId();
      }.bind(this),
    );
    const downloads = _.filter(
      this.state.downloads,
      function (download) {
        return download.work_id === this.docId();
      }.bind(this),
    );

    if (!doc || this.fetching) {
      return (
        <div className="u-taCenter u-pv4x">
          <i className="fa fa-spin fa-spinner u-fs36"></i>
        </div>
      );
    }

    return (
      <div>
        {doc.id !== Aedu.WorkConstants.CV_WORK_ID && (
          <div className="media_v2 u-mb6x">
            <div className="media-left media-middle">
              <Link
                to={this.props.match.path.slice(0, -7)}
                className="Button Button--inverseGray Button--sm"
              >
                <i className="fa fa-arrow-left"></i>&nbsp;&nbsp;Back
              </Link>
            </div>
            <div className="media-right media-middle">
              <a
                href={doc.internal_url}
                className="u-fs18 u-fontSerif u-tcGrayDarkest"
              >
                {doc.title}
              </a>
            </div>
          </div>
        )}
        {this.analyticsContent(doc, hits, downloads)}
      </div>
    );
  }

  analyticsContent = (doc, hits, downloads) => {
    if (_.isEmpty(hits)) {
      if (doc.id === Aedu.WorkConstants.CV_WORK_ID) {
        return (
          <CVAnalyticsTab title="Your curriculum vitae has no activity for this period." />
        );
      } else {
        return (
          <NoDataTab
            title="This paper has no recent activity."
            details="Check back later to see how many people are reading your paper."
            noUploadButton={true}
          />
        );
      }
    } else {
      return (
        <div>
          <ImpactTabContainer docId={this.docId()} />
          <DocumentsTabChart
            hits={hits}
            downloads={downloads}
            startDate={this.state.displayedDates.start}
            previousDateRangeDownloads={
              this.state.previousDateRangeDownloads.models
            }
            previousDateRangeHits={this.state.previousDateRangeHits.models}
            dayCount={this.state.displayedDates.dayCount}
          />
          <PremiumHitsTable hits={hits} />
          <CountriesPanel
            countries={doc.countries}
            countAttribute="thirtyDayViews"
            dayCount={this.state.displayedDates.dayCount}
          />
        </div>
      );
    }
  };

  state = this.getStateFromStore();
}
